import React from 'react';
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import {Route, Switch} from 'react-router-dom';

import {useTranslation} from "react-i18next";

import APITable from '../../../../Components/APITable';
import APIForm from '../../../../Components/APIForm';
import {concatURL} from "../../../../Components/utils";

const Notifications = ({url}) => {
    const {t, i18n} = useTranslation();

    const NOTIFICATION_CHANNEL_COLUMNS = [
        {
            name: t('settings.notification_channels.column.type', 'Type'),
            cell: row => <div>
                {t(row.type) && t(row.type.name)}
            </div>
        },
        {
            name: t('settings.notification_channels.column.active', 'Active'),
            cell: row => <div>
                {row.is_active ? '✅' : '⏹'}
            </div>
        },
        {
            name: t('settings.notification_channels.column.email', "Email"),
            selector: "email",
        },
        {
            name: t('settings.notification_channels.column.telegram_user', "Telegram user"),
            cell: row => <div>
                {t(row.tg_user_name)}
            </div>
        },
        {
            name: t('settings.notification_channels.column.tags', 'Tags'),
            cell: row => <div>
                {
                    get(row, 'tags', []).map(
                        (tag, idx) => <div className='my-1' key={idx}>
                            <code className='text-secondary'>
                                {tag.name}
                            </code>
                        </div>
                    )
                }
                {
                    isEmpty(row.tags) && '-'
                }
            </div>
        },
        {
            name: t('settings.notification_channels.column.unread_message', "Unread message"),
            selector: "tg_user_name",   // unread_message
            cell: row => <div>
                {t(row.unread_message) && t(row.unread_message.name)}
            </div>
        },
    ];

    const apiPath='notifications/channels';

    return <Switch>
        <Route
            exact path={`${url}/create/`}
            render={
                (props) => <>
                    <APIForm
                        apiPath={apiPath}
                        modelId={undefined}
                        method='post'
                        deletionDisabled={true}
                        actionRedirectUrl={`${url}/`}
                    />
                </>
            }
        />
    <Route
        exact path={`${url}/:id/`}
        render={
            props => <>
                <APIForm
                    apiPath={apiPath}
                    modelId={props.match.params.id}
                    method='patch'
                    actionRedirectUrl={`${url}/`}
                />
            </>
        }
    />
    <Route
        exact path={`${url}`}
        render={
            () => <APITable
                apiPath={apiPath}
                columnsConfig={NOTIFICATION_CHANNEL_COLUMNS}
                tableEmptyMessage={t('settings.notification_channels.list.no_data', 'No notifications channels are configured')}
                hasHeader={false}
                hasFilters={true}
                headerButtonCreateUrl={concatURL(url, 'create/')}
                tableCreateButton={true}
            />
        }
    />
</Switch>
};

export default Notifications;
